import {
    validateEmail,
    validateName,
    validatePhone,
    validateMessage,
    containsSqlInjection,
    containsXss,
    containsCodeInjection,
} from '../../../../context-module/context-configuration/permission-provider/validation/index';

export const validateSalesField = (name: string, value: string): string => { //NOSONAR
    // Check for injection attacks
    if (containsSqlInjection(value) || containsXss(value) || containsCodeInjection(value)) {
        return 'Input contains potentially dangerous content';
    }

    switch (name) {
        case 'fullName':
        case 'companyName': {
            const label = name === 'fullName' ? 'Full name' : 'Company name';
            const result = validateName(value, label);
            return result.errors.length > 0 ? result.errors[0] : '';
        }
        case 'businessEmail': {
            const result = validateEmail(value);
            return result.errors.length > 0 ? result.errors[0] : '';
        }
        case 'phone': {
            if (value) {
                const result = validatePhone(value);
                return result.errors.length > 0 ? result.errors[0] : '';
            }
            return '';
        }
        case 'message': {
            if (value) {
                const result = validateMessage(value, 300);
                return result.errors.length > 0 ? result.errors[0] : '';
            }
            return '';
        }
        default:
            return '';
    }
};
